export default {
  multiselect_adjustDropdown() {
    const select = this.$refs.select.$el
    const dropdown = $(select).find('.multiselect__content-wrapper')
    dropdown.hide()
    const width = $(select).width()
    dropdown.width(width - 2)
    dropdown.show()

    setTimeout(() => {
      $(dropdown).addClass('_detached')
      $('.dashboard-component').append(dropdown)

      let { top, left } = $(select).offset()

      top = parseInt(top)
      left = parseInt(left)

      dropdown.offset({
        top: top + parseInt($(select).height()),
        left,
      })
    }, 50)
  },
  multiselect_releaseDropdown() {
    const dropdown = $('.multiselect__content-wrapper._detached')

    dropdown.appendTo(this.$refs.select.$el)
    dropdown.removeClass('_detached')
  },
}
